import { withInstall } from '@xzx-design/utils'
import _Indexes from './src/indexes.tsx'
import _IndexAnchor from './src/index-anchor.tsx'

export const Indexes = withInstall(_Indexes)
export const IndexAnchor = withInstall(_IndexAnchor)
export default Indexes

export * from './src/types'
export * from './src/indexes'
export * from './src/index-anchor'
